import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import getColumns from './getColumns';
import TableLayout from '../shared/TableLayout';
import {
  selectDisplayColumnsForFuelTransactions,
  selectFuelTransactionWithUIEffect,
} from '../../redux/store/ui/common';
import {
  selectDisplayFuelTransactions,
  selectSelectedFuelTransaction,
  selectTotalFuelTransactions,
} from '../../redux/store/userData/fuelTransactions';
import { fetchFuelTransactions } from '../../redux/store/userData/fuelTransactions/thunk';
import { getFilteredColumns } from '../../utils';
import withPaginatedQueryFetch from '../../hoc/withPaginatedQueryFetch';

const FuelTransactionsTable = (props) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const displayFuelTransactions: any[] = useSelector(
    selectDisplayFuelTransactions
  );
  const fuelTransactionsNo = useSelector(selectTotalFuelTransactions);
  const selectedFuelTransaction: any = useSelector(
    selectSelectedFuelTransaction
  );
  const displayColumns = useSelector(selectDisplayColumnsForFuelTransactions);

  const columns = getColumns({ intl });
  const filteredColumns = getFilteredColumns(columns, displayColumns);

  const onClickRow = (record: any) => {
    dispatch(selectFuelTransactionWithUIEffect(record));
  };

  return (
    <TableLayout
      rowKey="fuelTransaction"
      columns={filteredColumns}
      dataSource={displayFuelTransactions}
      selectedId={selectedFuelTransaction?.id}
      totalNumber={fuelTransactionsNo}
      onClickRow={onClickRow}
      current={props.pageNumber}
      onPageChanged={props.onPageChanged}
    />
  );
};

export default withPaginatedQueryFetch(
  FuelTransactionsTable,
  fetchFuelTransactions
);
